export default "__VITE_ASSET__745ed91d__"